var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMais(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00004 3.66667C6.63337 3.66667 6.33337 3.96667 6.33337 4.33333V6.33333H4.33337C3.96671 6.33333 3.66671 6.63333 3.66671 7C3.66671 7.36666 3.96671 7.66667 4.33337 7.66667H6.33337V9.66667C6.33337 10.0333 6.63337 10.3333 7.00004 10.3333C7.36671 10.3333 7.66671 10.0333 7.66671 9.66667V7.66667H9.66671C10.0334 7.66667 10.3334 7.36666 10.3334 7C10.3334 6.63333 10.0334 6.33333 9.66671 6.33333H7.66671V4.33333C7.66671 3.96667 7.36671 3.66667 7.00004 3.66667ZM7.00004 0.333332C3.32004 0.333332 0.333374 3.32 0.333374 7C0.333374 10.68 3.32004 13.6667 7.00004 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7C13.6667 3.32 10.68 0.333332 7.00004 0.333332ZM7.00004 12.3333C4.06004 12.3333 1.66671 9.94 1.66671 7C1.66671 4.06 4.06004 1.66667 7.00004 1.66667C9.94004 1.66667 12.3334 4.06 12.3334 7C12.3334 9.94 9.94004 12.3333 7.00004 12.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMais);
export default __webpack_public_path__ + "static/media/ic_mais.1d8f6630959a36964934d66264f16522.svg";
export { ForwardRef as ReactComponent };